; (function () {


  const headerHeight = $("#header").outerHeight();

  $(document).on("click", ".nav-menu a, .mobile-nav a, .scrollto", function (e) {
    const pathname = location.pathname.replace(/^\//, "");
    const thisPathname = this.pathname.replace(/^\//, "");
    const hostnameMatch = location.hostname === this.hostname;

    if (pathname === thisPathname && hostnameMatch) {
      const target = $(this.hash);
      if (target.length) {
        e.preventDefault();

        let scrollTo = target.offset().top - scrolltoOffset;
        if ($(this).attr("href") === "#header") {
          scrollTo = 0;
        }

        $("html, body").animate(
          {
            scrollTop: scrollTo,
          },
          1500,
          "easeInOutExpo"
        );

        const navMenuParent = $(this).closest(".nav-menu, .mobile-nav");
        if (navMenuParent.length) {
          $(".nav-menu .active, .mobile-nav .active").removeClass("active");
          $(this).closest("li").addClass("active");
        }

        if ($("body").hasClass("mobile-nav-active")) {
          $("body").removeClass("mobile-nav-active");
          $(".mobile-nav-toggle i").toggleClass("icofont-navigation-menu icofont-close");
          $(".mobile-nav-overly").fadeOut();
        }

        return false;
      }
    }
  });

  // Ativa o scroll suave ao carregar a página com links de hash na URL
  $(document).ready(function () {
    try {
      $(".loading").fadeOut();
      let user = $(".user-wrapper > .btn-user");
      if (window.innerWidth < 1024 && user) {
        user.innerHTML = "<i class='fa fa-user'></i>"
      }
      let isExpanded = false;
      $(".expand-course").click(() => {
        const icon = $(".expand-course i");
        icon.toggleClass("fa-rotate-270");
        icon.toggleClass("fa-rotate-90");
        isExpanded = !isExpanded;
        if (isExpanded) {
          $("#courseAccordion").removeClass("col-md-3").addClass("collapsed");
          setTimeout(() => {
            $(".lesson-content-title").text(" ");
          }, 200)
          const item = $(".list-group-item");
          const finished = item.hasClass("finished");

          if (finished) {
            item.map((i) => {
              $(item[i]).hasClass("finished") ? $(item[i]).append("<i class='fas fa-check'></i>") : null
            })
          }
        } else {
          $("#courseAccordion").addClass("col-md-3").removeClass("collapsed");
          $(".lesson-content-title").text("Conteúdo do curso");
          if ($(".list-group-item").hasClass("finished")) {
            $(".list-group-item > i").remove();
          }
        }
      })

      const menuItems = $(".nav-menu .menu-primary-container a, .btn-go, #header .logo a");
      menuItems.on("click", function () {
        $(".loading svg").remove();
        $(".loading").fadeIn();
        const link = $(this).attr("href");
        window.location.href = link;
        $("html, body").animate(
          {
            scrollTop: 0,
          },
          800,
          "easeInOutExpo"
        );
        return false;
      });


      if (window.location.hash) {
        const initialNav = window.location.hash;
        if ($(initialNav).length) {
          const scrollto = $(initialNav).offset().top - scrolltoOffset;
          $("html, body").animate(
            {
              scrollTop: scrollto,
            },
            1500,
            "easeInOutExpo"
          );
        }
      }

      // Mobile Navigation
      if ($(".nav-menu").length) {
        const mobileNav = $(".nav-menu").clone().prop({
          class: "mobile-nav d-lg-none",
        });
        $("body").append(mobileNav);
        $("body header .container-fluid").append(
          '<button type="button" class="mobile-nav-toggle d-lg-none"><i class="fas fa-bars"></i></button>'
        );
        $("body").append('<div class="mobile-nav-overly"></div>');

        $(document).on("click", ".mobile-nav-toggle", function (e) {
          $("body").toggleClass("mobile-nav-active");
          $(".mobile-nav-toggle i").toggleClass("fas fa-bars far fa-times");
          $(".mobile-nav-overly").toggle();
        });

        $(document).on("click", ".mobile-nav .drop-down > a", function (e) {
          e.preventDefault();
          $(this).next().slideToggle(300);
          $(this).parent().toggleClass("active");
        });

        $(document).click(function (e) {
          const container = $(".mobile-nav, .mobile-nav-toggle");
          if (!container.is(e.target) && container.has(e.target).length === 0) {
            if ($("body").hasClass("mobile-nav-active")) {
              $("body").removeClass("mobile-nav-active");
              $(".mobile-nav-toggle i").toggleClass("fas fa-bars far fa-times");
              $(".mobile-nav-overly").fadeOut();
            }
          }
        });
      } else if ($(".mobile-nav, .mobile-nav-toggle").length) {
        $(".mobile-nav, .mobile-nav-toggle").hide();
      }

      // Estado ativo da navegação durante a rolagem
      const navSections = $("section");
      const mainNav = $(".nav-menu, #mobile-nav");

      $(window).on("scroll", function () {
        const curPos = $(this).scrollTop() + 200;

        navSections.each(function () {
          const top = $(this).offset().top;
          const bottom = top + $(this).outerHeight();

          // if (curPos >= top && curPos <= bottom) {
          //   if (curPos <= bottom) {
          //     mainNav.find('li').removeClass('active');
          //   }
          //   mainNav.find('a[href="#' + $(this).attr('id') + '"]').parent('li').addClass('active');
          // }
          // if (curPos < 300) {
          //   $(".nav-menu ul:first li:first").addClass('active');
          // }
        });
      });

      // Adiciona ou remove classe .header-scrolled do #header quando a página é rolada
      $(window).scroll(function () {
        if ($(this).scrollTop() > 100) {
          $("#header").addClass("header-scrolled");
          $("#hero").css("paddingTop", $("#header").outerHeight());
        } else {
          $("#header").removeClass("header-scrolled");
          $("#hero").css("paddingTop", 16);
        }
      });

      // if ($(window).scrollTop() > 100) {
      //   $("#hero").css("paddingTop", $("#header").outerHeight());
      //   $("#header").addClass("header-scrolled");
      // }

      // Botão "Voltar ao topo"
      $(window).scroll(function () {
        if ($(this).scrollTop() > 100) {
          $(".back-to-top").fadeIn("slow");
        } else {
          $(".back-to-top").fadeOut("slow");
        }
      });

      $(".back-to-top").click(function () {
        $("html, body").animate(
          {
            scrollTop: 0,
          },
          1500,
          "easeInOutExpo"
        );
        return false;
      });

      $(".go-to").click(function () {
        const goToPosition = $("#about").offset().top - 80;
        $("html, body").animate(
          {
            scrollTop: goToPosition,
          },
          1500,
          "easeInOutExpo"
        );
        return false;
      });

      // Foco na busca
      $(".search-toggle-button").on("click", function () {
        $("#header .search-field").focus();
      });

      // Vídeo modal
      if ($("[data-video]").length) {
        $("[data-video]").fancybox({
          openEffect: "fade",
          closeEffect: "fade",
          Html: {
            video: {
              autoplay: true,
            },
          },
        });
      }

      const liveSearch = $(location).attr("search");
      if (liveSearch) {
        const currentURL = liveSearch.split("?video=")[1];
        if (currentURL) {
          $("#video-" + currentURL).trigger("click");
        }
      }

      if ($("main").attr("id") === "course") {
        const isLogged = $("body").hasClass("logged-in");
        let videoId, maxwidth, options, currentVideo, $videoLesson, lessonHeight, videoPlayer;

        $videoLesson = $(".videoLesson");
        videoId = $videoLesson.data("id");
        currentVideo = currentVideo;
        maxwidth = $videoLesson.width();
        options = {
          id: videoId,
          maxwidth: maxwidth,
          maxheight: 550,
        };
        videoPlayer = new Vimeo.Player("videoLesson", options);
        lessonHeight;

        if (videoId) {
          $("#contentLesson").addClass("d-none");
          $("#videoLesson").removeClass("d-none");
        }

        // Carrega o conteúdo
        $(".content-button").click(function () {
          const $lesson = $(".lesson");
          const $this = $(this);

          const toLoad = $this.attr("href") + " .course-content";
          $("#contentLesson").load(toLoad, "");
          lessonType("content", $this);
          saveClass($this);
          return false;
        });

        // Carrega o vídeo
        $(".video-button").click(function () {
          const $lesson = $(".lesson");
          const $this = $(this);
          videoId = $this.data("vimeo");

          if (lessonHeight === undefined) {
            lessonHeight = $lesson.height();
            $lesson.css("minHeight", lessonHeight, $lesson.height());
          }
          if (!videoId) {
            $(".lesson").removeClass("lesson-bg");
          } else {
            $(".lesson").addClass("lesson-bg");
          }
          lessonType("video", $this);

          if (videoId !== currentVideo) {
            maxwidth = $videoLesson.width();
            videoPlayer.destroy();
            $videoLesson.data("vimeo-id", videoId);
            options = {
              id: videoId,
              maxwidth: maxwidth,
              maxheight: 550,
              autoplay: false,
            };
            videoPlayer = new Vimeo.Player("videoLesson", options);
            currentVideo = videoId;
            videoPlayer.loadVideo(videoId);
            saveClass($this);
          }
          return false;
        });

        function lessonType(type, $this) {
          const $lessonTitle = $(".lesson-title");
          const title = $this.data("title");
          $lessonTitle.html(title);

          if (type === "video") {
            $("#contentLesson").addClass("d-none");
            $("#videoLesson").removeClass("d-none");
          } else {
            $("#videoLesson").addClass("d-none");
            $("#contentLesson").removeClass("d-none");
          }
        }

        // Salva classe
        function saveClass($this) {
          if (isLogged) {
            const complete = $this.parent("li").hasClass("finished");
            $(".course a.active").toggleClass("active");
            $this.toggleClass("active");
            $this.parent("li").addClass("finished");
            if (!complete) {
              const lesson = $this.data("lesson");
              const $loader = $(".chart-progress .loader");
              $loader.show();
              $.ajax({
                type: "POST",
                data: { finished: lesson },
                success: function (response) {
                  const total = $(".progress").data("total");
                  const count = $(".finished").length;
                  const percentage = (100 * count) / total;
                  $(".progress-bar").css("width", percentage + "%");
                  if (response.type === "curso") {
                    if (response.certificado) {
                      $(".progress-certificate").fadeIn(function () {
                        $(".progress-certificate").attr("href", response.certificado);
                      });
                    }
                    $(".progress-bar").addClass("complete");
                    $(".progress-text").html("Curso completo");
                  }
                  $loader.fadeOut();
                },
              });
            }
          } // Fim do bloco "isLogged"
        }
      } // Fim do bloco "if course"

      // Modal
      let isLogged, $openArea, button, course, image, $course, $info, modal, logo, title, author, time, syllabus, certificate, url;
      isLogged = $("body").hasClass("logged-in");
      $openArea = $(".open-area");

      if ($openArea.length) {
        $(".open-area").on("click", function (e) {
          e.preventDefault();
          $(this).addClass("active");
          $("#menuModal").modal("show");
        });

        $("#menuModal")
          .on("show.bs.modal", function () {
            button = $(".open-area.active");
            course = button.data("course");
            $course = $("[data-course=" + course + "]");
            $info = $("[data-info=" + course + "]");
            modal = $(this);
            url = $info.find(".course-url").html();
            if (url) {
              modal.find(".modal-course_url").attr("href", url);
            }
            if ($course.attr("target")) {
              $(".modal-course_url").attr("target", "_blank");
            }
          })
          .on("hidden.bs.modal", function (e) {
            $(".open-area").removeClass("active");
          });
      }

      $("#assineModal")
        .on("show.bs.modal", function (e) {
          button = $(e.relatedTarget);
          course = button.data("course");
          image = button.data("image");
          $course = $("[data-course=" + course + "]");
          $info = $("[data-info=" + course + "]");
          modal = $(this);

          logo = $info.find(".course-logo .course-partner img").attr("src");
          title = $info.find(".course-item .course-title").html();
          author = $info.find(".course-item .course-author").html();
          time = $info.find(".course-item .course-time").html();
          syllabus = $info.find(".course-item .course-syllabus").html();
          certificate = $info.find(".course-item .course-certificate").html();
          url = $info.find(".course-item .course-url").html();

          if (image) {
            modal.find(".modal-course_image").attr("src", image);
          }
          if (title) {
            modal.find(".modal-course_title").html(title);
          }
          if (logo) {
            modal.find(".modal-course_logo").html('<img class=" mb-2" src="' + logo + '" alt="">');
          }
          if (author) {
            modal.find(".modal-course_author").html('<span class="d-block">' + author + "</span>");
          }
          if (time) {
            modal.find(".modal-course_time").html('<span class="d-block"><i class="bx bx-time-five"></i> Carga horária: ' + time + "</span>");
          }
          if (syllabus) {
            modal.find(".modal-course_syllabus").html('<span class="d-block"><i class="bx bx-list-ul"></i> ' + syllabus + "</span>");
          }
          if (certificate) {
            modal.find(".modal-course_certificate").html('<span class="tag d-block"><i class="fal fa-bookmark mr-1"></i> Certificado</span>');
          }
          if (url) {
            modal.find(".modal-course_url").attr("href", url);
          }
        })
        .on("hidden.bs.modal", function (e) {
          modal = $(this);
          modal.find(".modal-course_title, .modal-course_author, .modal-course_logo, .modal-course_time, .modal-course_syllabus, .modal-course_certificate").html("");
          modal.find(".modal-course_image").attr("src", "");
        });
      // Fim do modal

    } catch (e) {
      throw new Error(e);
    }
  }); // Fim do document ready
})(jQuery)

